import { BlogPostDetailType } from 'utilities/propTypes';

import PortableText from 'components/portableText';
import Photo from 'components/photo';
import Cell from '../grid/cell';
import Anchor from '../typography/anchor';
import Heading from '../typography/heading';
import { tile, title, image } from './BlogPostTile.module.scss';

const BlogPostTile = (props) => {
  const { post } = props;
  return (
    <Cell className={tile} size={2}>
      <Anchor href={post.route}>
        <Photo
          className={image}
          photo={post.mainImage}
          height={188}
          width={288}
          sizes="(min-width: 568px) and (max-width: 1024px) 50vw, (min-width: 1024px) 30vw, 100vw"
        />
        <Heading as="h3" className={title} size="h2">
          {post.title}
        </Heading>
        <PortableText
          blocks={post.description}
          renderLinks={false}
        ></PortableText>
      </Anchor>
    </Cell>
  );
};

export default BlogPostTile;

BlogPostTile.propTypes = BlogPostDetailType;
